import { Component, Injectable, ViewContainerRef, TemplateRef } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig } from '@angular/material';
import { Observable } from 'rxjs/Rx';
//import {Validators} from '@angular/forms';
import { ComponentType } from '@angular/cdk/portal';
import { AppMessages } from '../constants/messages';
import { Utility } from '../../common/utility';
import { DialogComponent } from '../../components/dialog/dialog.component';

@Injectable()
export class DialogService {

    constructor(private dialog: MatDialog) {
    }

    public openSuccessDialog(data) {
        data['type'] = 1; // success
        this.openDialog(data);
    }

    public openErrorDialog(data) {
        data['type'] = 2; // 2:error
        const dialogRef = this.openDialog(data);
        return dialogRef.afterClosed();
    }

    public openConfirmationDialog(data): Observable<any> {
        data['type'] = 3; // confirm
        data['yesOption'] = false;
        let dialogConfig = this.getDialogConfig();
        dialogConfig.data = data;
        let dialogRef = this.dialog.open(DialogComponent, dialogConfig);
        return dialogRef.afterClosed();
    }

    public getDialogConfig() {
        let config = new MatDialogConfig();
        config.disableClose = true;
        config.width = '600px';
        return config;
    }

    public openComponentDialog(componentOrTemplateRef, data?: Object, config?: MatDialogConfig): Observable<any> {
        let dialogConfig = Object.assign({}, this.getDialogConfig(), config);
        if (data) {
            dialogConfig.data = data;
        }
        let dialogRef = this.dialog.open(componentOrTemplateRef, dialogConfig);
        return dialogRef.afterClosed();
    }

    openDialog(data) {
        let dialogConfig = this.getDialogConfig();
        dialogConfig.data = data;
        let dialogRef = this.dialog.open(DialogComponent, dialogConfig);
        return dialogRef;
    }

    openNotificationDialog(data) {
        let dialogConfig = new MatDialogConfig();
        dialogConfig.hasBackdrop = false;
        dialogConfig.position = {top: '10px'};
        dialogConfig.width = '600px';
        dialogConfig['panelClass'] = 'notification-dialog-container';
        data['type'] = 4;
        dialogConfig.data = data;
        const dialogRef = this.dialog.open(DialogComponent, dialogConfig);
        return dialogRef;
    }
}




// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/shared/services/dialog.service.ts